import React from "react";
import { Box } from "@mui/material";
import TopBar from "./TopBar";
import Header from "./Header";
import Footer from "./Footer";
import OrganizationJsonLd from "../seo/OrganizationJsonLd";
import PageTransition from "./PageTransition";

export default function AppLayout() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <OrganizationJsonLd />
      <TopBar />
      <Header />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <PageTransition />
      </Box>
      <Footer />
    </Box>
  );
}
